module.exports = __webpack_public_path__ + "img/sv85.85c4aa4b.svg";